export default {
    history: 'History',
    date: 'Date',
    checkIn: 'Check-In',
    checkOut: 'Check-Out'
}
